import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Order from "@/model/order";

@Module({ namespaced: true })
export default class OrderModule extends VuexModule {
  public order: Order = null;
  public orderList: Order[] = [];

  @Mutation
  set(order: Order): void {
    this.order = order;
  }

  @Mutation
  setOrderList(order: Order[]): void {
    this.orderList = order;
  }

  @Mutation
  addOrderList(order: Order): void {
    this.orderList.push(order);
  }

  @Mutation
  editOrderList(order: Order): void {
    this.orderList.map((value, key) => {
      if (value.identifier === order.identifier) {
        this.orderList.splice(key, 1, order)
      }
    });
  }

  @Mutation
  remove(index: number): void {
    this.orderList.splice(index, 1);
  }

  @Action({ rawError: true })
  setOrder(order: Order) {
    this.context.commit("set", order);
  }

  @Action({ rawError: true })
  addOrderToList(order: Order) {
    this.context.commit("addOrderList", order);
  }

  @Action({ rawError: true })
  editOrderToList(order: Order) {
    this.context.commit("editOrderList", order);
  }

  @Action({ rawError: true })
  removeOrderInList(index: number) {
    this.context.commit("remove", index);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  clearList() {
    this.context.commit("setOrderList", []);
  }

  get getOrder(): Order {
    return this.order;
  }

  get getOrderList(): Order[] {
    this.orderList.map((order, index) => {
      if (order instanceof Order !== true) {
        this.orderList[index] = new Order(order);
      }
    })
    return this.orderList;
  }

  @Mutation
  setQuantity(value: any): void {
    this.orderList.map(item => {
      if (item.identifier === value.identifier) {
        item.quantity = value.quantity
      }
    })
  }

  @Action({ rawError: true })
  setQuantityToOrderItem(value: any) {
    this.context.commit("setQuantity", value);
  }

}
